import GetAcast from './get-acast';
import GetAcasts from './get-acasts-by-channel';
import GetAcastForPlayback from './get-acast-for-playback';
import GetChannel from './get-channel';
import GetChannelsByCategory from './get-channels-by-category';
import GetCuratedContent from './get-curated-content';
import GetLatestAcastForPlayback from './get-latest-acast-for-playback';
import GetPopularAcasts from './get-popular-acasts';
import GetPopularChannels from './get-popular-channels';
import GetSearchResults from './get-search-results';

export default {
  GetAcast,
  GetAcasts,
  GetAcastForPlayback,
  GetChannel,
  GetChannelsByCategory,
  GetCuratedContent,
  GetLatestAcastForPlayback,
  GetPopularAcasts,
  GetPopularChannels,
  GetSearchResults,
};



// WEBPACK FOOTER //
// ./client/queries/index.es6